import { logWrapper } from '../utils';

export default {
  executionHistoryModel: [
    'runtimeConstant',
    function (runtimeConstant) {
      function ExecutionHistory(data) {
        this.id = data.Id;
        this.idExecutionStep = data.IdExecutionStep;
        this.idUser = data.IdUser;
        this.action = data.Action;
        this.comments = data.Comments;
        this.form = data.Form ? data.Form : {};
        this.date = data.Date;

        this.user = data.User;
        this.step = data.ExecutionStep;
      }

      function icon() {
        var icons = [];

        icons['view'] = 'md md-pageview';
        icons['download'] = 'md md-file-download';
        icons['edit'] = 'md md-edit';
        icons['sign'] = 'md md-award';
        icons['send'] = 'md md-file-upload';
        icons['notify'] = 'md md-email';
        icons['update'] = 'md md-file-upload';
        icons['cancel'] = 'md md-cancel';
        icons['checkin'] = 'md md-file-upload';
        icons['finish'] = 'md md-beenhere';
        icons['releaseDocument'] = 'fa fa-unlock-alt';
        icons['properties'] = 'md md-settings';

        return icons[this.action];
      }

      function title() {
        var titles = [];

        titles['view'] = 'VIEW DOCUMENT';
        titles['download'] = 'DOWNLOAD';
        titles['edit'] = 'EDIT';
        titles['sign'] = 'SIGN';
        titles['send'] = 'SEND DOCUMENT';
        titles['notify'] = 'NOTIFY';
        titles['update'] = 'UPDATE';
        titles['cancel'] = 'CANCEL';
        titles['checkin'] = 'CHECKIN';
        titles['finish'] = 'FINISH';
        titles['properties'] = 'PROPERTIES';

        return titles[this.action];
      }

      function run() {
        try {
          ExecutionHistory.prototype = {
            icon: logWrapper(icon, runtimeConstant.isDebugModelsInternals),
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
          };

          return ExecutionHistory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
